import { MarkerClusterer } from '@googlemaps/markerclusterer'

window.MarkerClusterer = MarkerClusterer
